import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { takeUntil, timestamp } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Store } from 'src/app/core/store/store';
import { DashboardService } from '../../services/dashboard.service';
import { User } from 'src/app/shared/models/user.model';
import { ToastrService } from 'ngx-toastr';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { CommonService } from 'src/app/shared/services/common.service';
import { EventsService } from 'src/app/shared/services/events.service';

@Component({
  selector: 'app-dashboard-banner-new',
  templateUrl: './dashboard-banner-new.component.html',
  styleUrls: ['./dashboard-banner-new.component.scss']
})
export class DashboardBannerNewComponent extends HandleSubscription implements OnInit {
  @Input() program: any;
  @Input() activationInfo: any;
  // activationInfo: any;
  prog: any;
  ispopUpShow: boolean = false;
  showBannerModal = false;
  showDescriptionModal = false;
  private data: any;
  programData: boolean = false;
  user: User;
  btnText: string;
  bannerBtnTxt = true;
  buttonReport = false;
  showFeedback = false;
  completedItemObj: any;
  currentCardName;
  showProgramEndVideo;
  showMasterClassThreshold = false;
  programDashboardId;
  masterClassObjId;
  showIntroVideo;
  totalCourses;
  shownewFeedback = false;
  @Output() currentItemBlock: any = new EventEmitter();
  showProgramCompletionModal = false;
  currentBlockNumber;
  isProgramStarted = false;
  courseDaysPending:any;
  @Input() isProgramCompletionDatePassed;
  activationInfoTitle: any;

  constructor(private router: Router, private dashboardService: DashboardService, private store: Store, private toaster: ToastrService, private cs: CommonService,
    private eventsService: EventsService) {
    super();
  }


  ngOnInit(): void {
    this.activationInfoTitle = JSON.parse(localStorage.getItem('activationInfo'))
    if (this.program.length) {
      this.programData = this.program[0]['showProgaamIntroVideo']
      if (this.activationInfo['introduction'].disableVideo) {
        this.showIntroVideo = false;
        this.showBannerModal = false;
      } else {
        if (this.programData) {
          this.openModal();
        }
        this.showIntroVideo = true;
      }
      this.prog = this.program[0]['program'];
      this.isProgramResumeStart();
    }

    this.store.select('user').pipe(takeUntil(this.unsubscribe$)).subscribe((user: any) => {
      this.user = user;
    });

    this.store.select('activation').pipe(takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
      if(activation) {
        this.program = activation;
        this.prog = activation[0]['program'];
        this.isProgramResumeStart();
      }
    });

    this.store.select('activationInfo').pipe(takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
      if(activation) {
        this.activationInfo = activation;
        if (this.activationInfo['introduction'].disableVideo) {
          this.showIntroVideo = false;
          this.showBannerModal = false;
        } else {
          if (this.programData) {
            this.openModal();
          }
          this.showIntroVideo = true;
        }
      }
    });

    this.updateBannerShowModal();
    this.singleCourseChecking();
    // Check for next item to start
    if(localStorage.getItem('playVideo') || localStorage.getItem('skipOptional') || localStorage.getItem('navNextItem')) {
      // set null, true for cleverTap event click next
      this.checkNextNavigation(null, true);
    }
    // this.getActivationInfo(this.program[0]['programActivationId'])
    // capture event
    this.captureViewDashboard();
  }
  // Checking for no. of course
  singleCourseChecking() {
    this.totalCourses = 0;
    for (let i = 0; i < this.program.length; i++) {
      if (this.program[i].type === "COURSE") {
        this.totalCourses++;
      }
    }
    if (this.totalCourses === 1) {
      for (let i = 0; i < this.program.length; i++) {
        if (this.program[i].type === "COURSE") {
          if(this.activationInfo.enableCourseWiseFeedback) {
            this.shownewFeedback = true;
          } else {
            this.shownewFeedback = false;
          }
        }
      }
    } else {
      this.shownewFeedback = false;
    }
  }

  openDescriptionModal(){
    this.showDescriptionModal= true;
  }

  openModal() {
    //this.openModal();
    // this.showIntroVideo = true;
    this.showBannerModal = true;
    // capture event
    try {
      if(this.user && this.prog) {
        let eventData = { user: this.user, program: this.prog }
        this.eventsService.watchProgramIntroEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  closeDescriptionModel(value){
    this.showDescriptionModal= false;
  }

  closeModel(value) {
    if (this.programData) {
      this.data = {
        "programId": this.program[0]['programId'],
        "activationId": this.program[0]['programActivationId']
      }
      this.dashboardService.introVideoWatched(this.data).subscribe(res => {
        this.programData = false;
      })
    }
    this.showBannerModal = false;
    // capture event
    try {
      if(this.user && this.prog) {
        let eventData = { user: this.user, program: this.prog }
        this.eventsService.stopProgramIntroEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  closeModelEndVideo(value) {
    this.data = {
      "programId": this.activationInfo['programId'],
      "activationId": this.activationInfo['programActivationId']
    }
    this.dashboardService.endVideoWatched(this.data).subscribe(res => {
      if(res) {
        // this.getProgramActivation();
      localStorage.setItem('navNextItem', 'true');
      this.cs.reloadRoute('/dashboard');
      }
    })
    this.showProgramEndVideo = false;
    // capture event
    try {
      if(this.user && this.prog) {
        let eventData = { user: this.user, prog: this.prog }
        this.eventsService.watchProgCompletionEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  goToNextItem(event?) {
    this.checkNextNavigation(event);
  }

  checkNextNavigation(event?, clickNext?) {

    if(localStorage.getItem('playVideo')) {
      localStorage.removeItem('playVideo');
    }
    if(localStorage.getItem('skipOptional')) {
      localStorage.removeItem('skipOptional');
    }
    if(localStorage.getItem('navNextItem')) {
      localStorage.removeItem('navNextItem');
    }

    if (!this.activationInfo.progress || (this.activationInfo.progress && this.activationInfo.progress < 100)) {
      /* let prePostObj = this.prog.dashboard.find(x => x.status.islock == false && x.status.progress < 100 && (x.type == 'PRE' || x.type == 'POST'));
      let courseObj = this.prog.dashboard.find(x => x.status.islock == false && x.status.progress < 100 && x.type == 'COURSE');
      let masterclassObj = this.prog.dashboard.find(x => x.status.islock == false && x.type == 'MASTERCLASS' && x.status.progress < 100 && !x.status.upcoming); */
      // capture events
      try {
        if(!this.isProgramStarted && event) {
        //   if(this.program[0].program && this.user && this.currentCardName) {
        //     let eventData = { 'program': this.program[0].program, 'user': this.user, 'currentCardName': this.currentCardName }
        //     this.eventsService.startProgramEvent(eventData);
        //   }
        // } else if(this.isProgramStarted && event) {
          if(this.program[0] && this.user && this.currentCardName && this.currentBlockNumber) {
            let eventData = { 'activationData': this.program[0], 'user': this.user, 'currentCardName': this.currentCardName, 'currentBlockNumber': this.currentBlockNumber }
            this.eventsService.resumeProgramEvent(eventData);
          }
        }
      } catch (err) {
        console.log(err);
      }
      // Find next item to start & to show optional modal & start next item block or start current item block, if they are unlocked
      let dashboard = this.program;
      const masterclassInfo = dashboard.find(x=> x?.type == 'MASTERCLASS' && x?.status.islock == false && x?.status.upcoming == false && x?.status.progress < 100 && x?.status.isMeetingEnd== false);
      if(masterclassInfo ){
        if(!masterclassInfo?.isOptionalToComplete || (masterclassInfo?.isOptionalToComplete && !masterclassInfo?.status.skipOptionalBlock)){
          this.currentItemBlock.emit(masterclassInfo);
          return;
        }
      }
      for (let i = 0; i < dashboard.length; i++) {
        // To start mandatory item block
        if((dashboard[i].status.islock == false) && (dashboard[i].status.progress < 100) && !dashboard[i].isOptionalToComplete) {
          if((dashboard[i].type == 'PRE') || (dashboard[i].type == 'POST') || (dashboard[i].type == 'COURSE') || (dashboard[i].type == 'MASTERCLASS') || (dashboard[i].type == 'ASSESSMENT') || (dashboard[i].type == 'INTEGRATION')) {
            if((dashboard[i].type == 'MASTERCLASS')  && (!dashboard[i].status.upcoming || dashboard[i].recordedLink) ) {
              this.currentItemBlock.emit(dashboard[i]);
              // if(clickNext) { this.captureClickNextEvent(dashboard[i]); }
              break;
            } else if ((dashboard[i].type == 'PRE') || (dashboard[i].type == 'POST') || (dashboard[i].type == 'COURSE') || (dashboard[i].type == 'ASSESSMENT') || (dashboard[i].type == 'INTEGRATION') ){
              this.currentItemBlock.emit(dashboard[i]);
              // if(clickNext) { this.captureClickNextEvent(dashboard[i]); }
              break;
            }
          }
        }
        // check optional item block, if exists then show optional modal
        else if((dashboard[i].status.islock == false) && (dashboard[i].status.progress == 0) && dashboard[i].isOptionalToComplete && !dashboard[i].status.skipOptionalBlock) {
          if((dashboard[i].type == 'PRE') || (dashboard[i].type == 'POST') || (dashboard[i].type == 'COURSE') || (dashboard[i].type == 'MASTERCLASS') || (dashboard[i].type == 'ASSESSMENT') || (dashboard[i].type == 'INTEGRATION')) {
            if((dashboard[i].type == 'MASTERCLASS') && (!dashboard[i].status.upcoming || dashboard[i].recordedLink)){
              this.currentItemBlock.emit(dashboard[i])
              return;
            } else if ((dashboard[i].type == 'PRE') || (dashboard[i].type == 'POST') || (dashboard[i].type == 'COURSE') || (dashboard[i].type == 'ASSESSMENT') || (dashboard[i].type == 'INTEGRATION') ) {
              this.currentItemBlock.emit(dashboard[i])
              return;
            }
          }
        }

      }

      /* if (prePostObj && prePostObj.type == 'PRE') {
        this.router.navigate([`/benchmarking/pre-test`]);
      } else if ((masterclassObj && !masterclassObj.status.isMeetingEnd) || (masterclassObj && masterclassObj.status.isMeetingEnd && masterclassObj.recordedLink && masterclassObj.recordedLink !== '') ) {
        if(masterclassObj && masterclassObj.status.isMeetingEnd && masterclassObj.recordedLink && masterclassObj.recordedLink !== '' && courseObj) {
          this.store.set('courseStart', { activationId: this.prog.activation._id, programDashboardId: courseObj.programDashboardId, activationDashboardType: 'COURSE', courseId: courseObj.courseId, item: courseObj });
        } else {
          this.store.set('zoomStart', { activationId: this.prog.activation._id, programDashboardId: masterclassObj.programDashboardId, item: masterclassObj});
        }
      } else if (courseObj) {
        this.store.set('courseStart', { activationId: this.prog.activation._id, programDashboardId: courseObj.programDashboardId, activationDashboardType: 'COURSE', courseId: courseObj.courseId, item: courseObj });
      } else if (prePostObj && prePostObj.type == 'POST') {
        this.router.navigate([`/benchmarking/post-test`]);
      } */
    } else if(this.activationInfo.progress && this.activationInfo.progress == 100) {
      if(!this.activationInfo.completed) {
        // video play program
        if (this.activationInfo['onCompletion'].disableVideo) {
          this.showProgramEndVideo = false;
        } else {
          this.showProgramEndVideo = true;
        }
      } else {
        if(!this.activationInfo.enableProgramCertificate && !this.activationInfo.showProgramPerformanceReport) {
          // show program completion modal
          this.showProgramCompletionModal = true;
        }
        if(this.activationInfo.enableProgramCertificate && !this.activationInfo.showProgramPerformanceReport) {
          this.goToCertificate(this.activationInfo?.programCertificate?.certificateId)
        } 
        if (!this.activationInfo.enableProgramCertificate && this.activationInfo.showProgramPerformanceReport || this.activationInfo.enableProgramCertificate && this.activationInfo.showProgramPerformanceReport)
          this.router.navigate(['/dashboard/reports-certificate']);
        {
          //  capture event
          try {
            if (this.user && this.program[0]) {
              let eventData = { user: this.user, activationData: this.program[0] };
              this.eventsService.viewCertificateTranscriptEvent(eventData);
            }
          } catch (err) { console.log(err); }
        }
      }
    }
  }

  goToCertificate(id) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/program-certificate/${id}`])
    );
    window.open(url, '_blank');
    // capture event
    try {
      if(this.user && this.program[0]['program'].activation && this.program[0]['program'].activation.length){
        let eventData = { 'user': this.user, 'activationData': this.program[0]['program'].activation[0] }
        this.eventsService.viewCertificateEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Show feedback form,
   * Threshold popover for masterclass,
   * Update banner current block name & btn state,
   * Program completion video
   */
  updateBannerShowModal() {

    /* this.completedItemObj = this.prog.dashboard.find(x => x.status.islock == false && x.status.progress == 100 && x.status.isCompleted == false);
    if(this.completedItemObj && this.completedItemObj.status && this.completedItemObj.status.isCompleted == false) {
      this.showFeedback = true;
    } */
    let dashboard = this.program;
    // console.log(dashboard)
    // open feedback form on block completion
    for (let i = 0; i < dashboard.length; i++) {
      if((dashboard[i].status.islock == false) && (dashboard[i].status.progress == 100) && (dashboard[i].status.isCompleted == false) && ((dashboard[i].type == 'COURSE') || (dashboard[i].type == 'MASTERCLASS'))) {
        if((dashboard[i].type == 'COURSE') && this.activationInfo.enableCourseWiseFeedback && this.activationInfo.enableProgramFeedback) {
          continue;
        }
        this.completedItemObj = dashboard[i];
        this.showFeedback = true;
        return;
      }
    }

    if (!this.activationInfo.progress || (this.activationInfo.progress && this.activationInfo.progress < 100)) {
      let prePostObj = this.program.find(x => x.status.islock == false && x.status.progress < 100 && (x.type == 'PRE' || x.type == 'POST'));
      let courseObj = this.program.find(x => x.status.islock == false && x.status.progress < 100 && x.type == 'COURSE');
      let masterclassObj = this.program.find(x => x.status.islock == false && x.type == 'MASTERCLASS' && !x.status.upcoming && x.status.progress < 100 );
     // let masterclassPopOver = this.prog.dashboard.find(x => (x.status.islock == false) && (x.type == 'MASTERCLASS') && !x.status.upcoming && (x.status.progress < 100) && x.status.started && !x.status.isProgressPopOverViewed); 


      
      for (let i = 0; i < dashboard.length; i++) {
        // To start mandatory item block
        if((dashboard[i].status.islock == false) && (dashboard[i].status.progress < 100)) {
          if((dashboard[i].type == 'PRE') || (dashboard[i].type == 'POST') || (dashboard[i].type == 'COURSE') || (dashboard[i].type == 'MASTERCLASS') || (dashboard[i].type == 'ASSESSMENT') || (dashboard[i].type == 'INTEGRATION')) {
            // started true &&  isPopover false, show popover
            if((dashboard[i].type == 'MASTERCLASS') && !dashboard[i].status.upcoming && dashboard[i].status.started && dashboard[i].status.isMeetingEnd && !dashboard[i].status.isProgressPopOverViewed) {
              this.showMasterClassThreshold = true;
              this.programDashboardId = dashboard[i].programDashboardId;
              this.masterClassObjId = dashboard[i].masterClassObjects[0]._id;
              break;
            }
            // if skip optional is true then continue loop
            if(dashboard[i].status.skipOptionalBlock) {
              continue;
            }
            this.currentCardName =  dashboard[i].title;
            this.bannerBtnTxt = true;
            this.currentBlockNumber = dashboard[i].order;
            break;
          }
        } else {
          // this.currentCardName = 'COMPLETED'
          this.bannerBtnTxt = false;
        }
      }



      if (prePostObj && prePostObj.type == 'PRE') {
        this.currentCardName =  prePostObj.title;
        this.bannerBtnTxt = true;
      } else if ((masterclassObj && !masterclassObj.status.isMeetingEnd) || (masterclassObj && masterclassObj.status.isMeetingEnd && masterclassObj.recordedLink && masterclassObj.recordedLink !== '') ) {
        if(masterclassObj && masterclassObj.status.isMeetingEnd && masterclassObj.recordedLink && masterclassObj.recordedLink !== '' && courseObj) {
          this.currentCardName = courseObj.title;
          this.bannerBtnTxt = true;
        } else {
          this.currentCardName =  masterclassObj.title;
          this.bannerBtnTxt = true;
        }
      } else if (courseObj) {
        this.currentCardName = courseObj.title;
        this.bannerBtnTxt = true;
      } else if (prePostObj && prePostObj.type == 'POST') {
        this.currentCardName =  prePostObj.exercise.title;
        this.bannerBtnTxt = true;
      } else {
        // waiting next
        this.bannerBtnTxt = false;
        let lastPrePostObj = this.program.find(x => x.status.islock == false && x.status.progress == 100 && (x.type == 'PRE' || x.type == 'POST'));
        let lastItem = null;
        for (let i = 0; i < this.program.length; i++) {
          if(this.program[i].status.progress == 100) {
            lastItem = this.program[i];
          }
        }
        if(lastPrePostObj && lastPrePostObj.type == 'POST' ) {
          this.currentCardName = lastPrePostObj.exercise.title;
        } else if(lastPrePostObj && !lastItem) {
          this.currentCardName = lastPrePostObj.exercise.title;
        } else if(lastItem){
          this.currentCardName = lastItem.title; 
        }

      } 
    } else if(this.activationInfo.progress == 100) {
      // resume text btn
      // program end video play
      if(!this.activationInfo.completed) {
        this.currentCardName = 'COMPLETION VIDEO';
        // video play program
        if (this.activationInfo['onCompletion'].disableVideo) {
          this.showProgramEndVideo = false;
        } else {
          this.showProgramEndVideo = true;
        }
      } else {
        this.currentCardName = 'COMPLETED';
        // btn text report & feedback
        this.buttonReport = true;
      }
      // try {
      //   this.captureCompleteProgramEvent();
      // } catch (err) {
      //   console.log(err);
      // }
    }

  }



  startZoom(item) {
    if ((item && item.status && item.status.islock) || item.status.upcoming) {
      return;
    }
    let meetingNum;
    // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    //   this.toaster.info("Please log in through your laptop/desktop to access this session");
    //   return;
    // }
    if (item && item.masterClassObjects.length) {
      meetingNum = item.masterClassObjects[0].meetingId;
    }

    localStorage.setItem('email', this.user.email);
    localStorage.setItem('meetingId', meetingNum);
    localStorage.setItem('userName', `${this.user.firstName} ${this.user.lastName}`);
    localStorage.setItem('pathwayUrl', window.location.href);
    window.open(`/zoom-meeting`, '_blank');
  }

  hideFeedback(val) {
    this.showFeedback = val;
  }

  getProgramActivation() {
    this.dashboardService.getProgramActivation().subscribe((res) => {
      if(res && res['data']) {
        this.store.set('courseStart', null);
        this.store.set('zoomStart', null);
        this.store.set('activation', res['data']);
      }
    });
  }

  hideMasterClassThreshold(value) {
    this.showMasterClassThreshold = value;
    let data = {
      activationId: this.activationInfo.programActivationId, programDashboardId: this.programDashboardId, activationDashboardType: 'MASTERCLASS',
      masterClassObjectId: this.masterClassObjId, isProgressPopOverViewed: true
    };

    this.dashboardService.masterclassThreshold(data).subscribe((res) => {
    });
  }

  hideProgCompletionModal(value) {
    this.showProgramCompletionModal = value;
  }

  // checking program start/resume to capture event
  isProgramResumeStart(){
    try {
      if(this.program) {
        this.isProgramStarted = this.program.some(x => x.status.started == true);
      }
    } catch (err) {
      console.log(err);
    }
  }

  // captureCompleteProgramEvent() {
  //   if(this.user && this.program && this.program[0]) {
  //     // let timeDiff = 0;
  //     let completedDate: any = new Date(this.program[0].completedOn);
  //     let currentDate: any = new Date();
  //     // timeDiff = currentDate - completedDate;
  //     if (completedDate.toDateString() === currentDate.toDateString()) {
  //       let eventData = { user: this.user, activationData: this.program[0] }
  //       this.eventsService.completeProgramEvent(eventData);
  //     }
  //   }
  // }

  //capture event click 'Next'
  /* captureClickNextEvent(item) {
    try {
      if(this.user && this.program && item){
        let eventData = { user: this.user, activationData: this.program[0], source: item };
        this.eventsService.clickNextEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  } */

  captureViewDashboard() {
    try {
      if(this.user && this.program && this.program.length) {
        let eventData = { user: this.user, activationData: this.program[0] };
        this.eventsService.viewDashboardEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }

  
}
